import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20cinematic%20scene%20with%20a%20smartphone%20displaying%20glowing%20text%20messages%20in%20Chinese%20on%20a%20dark%20surface%2C%20surrounded%20by%20scattered%20newspaper%20clippings%20and%20magnifying%20glass%2C%20deep%20red%20and%20amber%20accent%20light%20streaks%2C%20moody%20film%20noir%20atmosphere%20with%20high%20contrast%2C%20editorial%20photojournalism%20style%20with%20dramatic%20shadows%20and%20warm%20highlights%2C%20mysterious%20and%20investigative%20mood&width=1600&height=900&seq=home-hero-2026&orientation=landscape"
        alt="51大赛吃瓜黑料网 - 吃瓜第一线"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/90 text-white text-xs md:text-sm font-medium mb-5 md:mb-7 whitespace-nowrap backdrop-blur-sm animate-fade-in" style={{ animationDelay: '0.2s', opacity: 0 }}>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-fire-line"></i>
            </div>
            实时更新 · 每日大赛最新爆料
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white mb-4 md:mb-6 leading-tight max-w-3xl animate-fade-in-up" style={{ animationDelay: '0.4s', opacity: 0 }}>
            吃瓜第一线，
            <br className="hidden sm:block" />
            黑料大瓜不隔夜
          </h1>

          <p className="text-white/80 text-sm md:text-lg max-w-xl mb-7 md:mb-9 leading-relaxed animate-fade-in-up" style={{ animationDelay: '0.6s', opacity: 0 }}>
            深度吃瓜爱好者聚集地，聚焦网红明星塌房现场、博主反差猛料及私密聊天记录流出。每日更新，绝不错过任何一个大瓜。
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-3 animate-fade-in-up" style={{ animationDelay: '0.8s', opacity: 0 }}>
            <Link
              to="/category/daily-competition"
              className="px-7 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即吃瓜
              <div className="w-4 h-4 inline-flex items-center justify-center ml-1.5">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
            <Link
              to="/about"
              className="px-7 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white font-medium text-sm md:text-base border border-white/25 hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}